import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { range } from 'lodash-es';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

export const SensitivitySkeleton: FC<{ className?: string }> = ({ className }) => (
  <div className={classNames('bg-lvl1 d-flex justify-content-end flex-wrap', className)}>
    <CardSkeleton titleKey="quoteDetails.Tab.Greeks" />
    <CardSkeleton titleKey="quoteDetails.Tab.Fees" />
    <CardSkeleton titleKey="quoteDetails.Tab.Metrics" />
  </div>
);

const CardSkeleton: FC<{ titleKey: IntlKey; itemsCount?: number }> = ({ titleKey, itemsCount = 4 }) => {
  const { formatMessage } = useIntl();
  return (
    <div className="card">
      <div className="card-header py-3 text-secondary">
        <h3 className="card-title line-height-1 mb-2">{formatMessage({ id: titleKey })}</h3>
      </div>
      <div className="card-body pb-2">
        <table className="table table-sm table-striped my-0">
          <tbody>
            {range(0, itemsCount).map(k => (
              <tr key={k}>
                <th>
                  <Skeleton width="8em" />
                </th>
                <td>
                  <Skeleton width="8em" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
